import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

const styles = {
  root: {
    flexGrow: 1
  },
  appbar: {
    backgroundColor: '#3f51b5'
  }
};

const I3AppBar = props => {
  const { classes, text } = props;

  return (
    <div className={classes.root}>
      <AppBar className={classes.appbar} position="static">
        <Toolbar>
          <Typography variant="h6" color="inherit">
            {text}
          </Typography>
        </Toolbar>
      </AppBar>
    </div>
  );
};

I3AppBar.propTypes = {
  classes: PropTypes.object.isRequired,
  text: PropTypes.string
};
I3AppBar.defaultProps = {
  text: ''
};

export default withStyles(styles)(I3AppBar);
